// Wrappers para /api/admin/*.

import { apiFetch } from './api';

export interface AdminUser {
  id: number;
  email: string;
  display_name: string;
  status: 'active' | 'suspended' | 'pending' | 'deleted';
  level_id: number | null;
  license_id: number | null;
  license_slug: string | null;
  assigned_teacher_id: number | null;
  assigned_teacher_name: string | null;
  roles: string;
}

export interface ListUsersResponse {
  status: 'ok';
  items: AdminUser[];
  total: number;
}

export interface ListUsersFilter {
  role?: string;
  q?: string;
  license_id?: number;
  teacher_id?: number;
  no_teacher?: boolean;
  limit?: number;
  offset?: number;
}

export async function listAdminUsers(filter: ListUsersFilter = {}): Promise<ListUsersResponse> {
  const q = new URLSearchParams();
  if (filter.role) q.set('role', filter.role);
  if (filter.q) q.set('q', filter.q);
  if (filter.license_id !== undefined) q.set('license_id', String(filter.license_id));
  if (filter.teacher_id !== undefined) q.set('teacher_id', String(filter.teacher_id));
  if (filter.no_teacher) q.set('no_teacher', 'true');
  if (filter.limit !== undefined) q.set('limit', String(filter.limit));
  if (filter.offset !== undefined) q.set('offset', String(filter.offset));
  const qs = q.toString();
  return apiFetch<ListUsersResponse>(`/admin/users${qs ? `?${qs}` : ''}`);
}

export async function updateAssignment(
  userId: number,
  assignment: { assigned_teacher_id?: number | null; license_id?: number | null }
): Promise<void> {
  await apiFetch(`/admin/users/${userId}/assignment`, {
    method: 'PATCH',
    body: JSON.stringify(assignment),
  });
}
